// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6146":"d50a41be","8108":"1d3499fc"}[chunkId] + ".chunk.css";
};